import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';



const styles = theme => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    width: 'fit-content',
  },
  formControl: {
    marginTop: theme.spacing.unit * 2,
    minWidth: 120,
  },
  formControlLabel: {
    marginTop: theme.spacing.unit,
  },
});

class Customerdetails extends React.Component {

  state = {
    openDetails: false,
    fullWidth: true,
    maxWidth: 'xs',
    customerDetails: [],
  };


  handleClose = () => {
    this.setState({ openDetails: false });
  };

  render() {
    const { classes } = this.props;
    let remark = this.props.remark;
    return (
      <div>
        <u style={{color: '#4574A3'}} id='pointer' onClick={ () => { this.setState({ openDetails: true }) }}>{'Remarks'}</u>
        <React.Fragment>
          <Dialog fullWidth={this.state.fullWidth} maxWidth={this.state.maxWidth}
            open={this.state.openDetails} onClose={this.handleClose}
            aria-labelledby="max-width-dialog-title">
            <DialogTitle id="max-width-dialog-title">Remark</DialogTitle>
            <DialogContent>
              {remark}
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleClose} color="primary">
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </React.Fragment>
      </div>
    );
  }
}

Customerdetails.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Customerdetails);
